export enum QueryParamsEnum {
  GET_POSITION = "?getPosition"
}
